import GhostBar from "./GhostBar";

const GhostDonutBreakdown = () => {
  return (
    <>
      {/* 1. Header Mirror */}
      <div className="spending-breakdown-header">
        <div className="card-title">
          <h4 className="carousel-title margin-reset">
            <GhostBar width="180px" height="22px" />
          </h4>
        </div>
        <div
          className="full-width align-center"
          style={{ display: "flex", marginTop: "12px" }}
        >
          <div className="utc-header-filtering">
            <GhostBar
              width="50px"
              height="20px"
              style={{ borderRadius: "4px" }}
            />
            <GhostBar
              width="50px"
              height="20px"
              style={{ borderRadius: "4px" }}
            />
          </div>
        </div>
      </div>

      {/* 2. Body Mirror */}
      <div className="spending-breakdown-body">
        {["By Category", "By Account"].map((label, idx) => (
          <div key={idx} className="spending-donut-chart-section">
            <h5 style={{ marginBottom: "20px" }}>
              <GhostBar width="100px" height="18px" />
            </h5>

            {/* Mirroring className="donut-with-legend-container" */}
            <div
              className="donut-with-legend-container"
              style={{ display: "flex", alignItems: "center", gap: "30px" }}
            >
              {/* 1. Donut Visual Mirror */}
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {/* The outer Ring */}
                <GhostBar width="150px" height="150px" circle />
                {/* The Center Label/Value Hole */}
                <div
                  style={{
                    position: "absolute",
                    width: "90px",
                    height: "90px",
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  <GhostBar width="30px" height="8px" /> {/* "Total" */}
                  <GhostBar width="50px" height="12px" /> {/* "$12,345" */}
                </div>
              </div>

              {/* 2. Legend List Mirror */}
              <div
                className="donut-legend-list"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  flex: 1,
                }}
              >
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between", // Match real logic
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {/* Color Dot (Circle) */}
                      <GhostBar width="10px" height="10px" circle />
                      {/* Label text */}
                      <GhostBar
                        width={i === 1 ? "80px" : "60px"}
                        height="10px"
                      />
                    </div>
                    {/* Price Value text (Right aligned) */}
                    <GhostBar width="40px" height="10px" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GhostDonutBreakdown;
